import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import useAuth from "src/hooks/useAuth";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";

const CardTransferCard = ({ 
  user, 
  changeBlock,
  key,
  block,
  cardId, 
  availableUsers, 
  onCardTransferred
 }) => {
  const { cliente } = useAuth();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [users, setUsers] = useState([]);
  console.log('block', block);
  console.log('index', key);

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);


  return (
    <div className="w-full">
        <div className="space-y-4">
          {/* Seleção de Usuário */}
          <div>
            <label className="block text-sm font-medium">Usuário</label>
            <Select
            value={block?.data?.cardTransferUsers}
              onValueChange={(value) =>{
                let event = {
                  name: "cardTransferUsers",
                  value: value,
                }
                changeBlock(event)
              }}
              className="w-full"
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Selecione um usuário" />
              </SelectTrigger>
              <SelectContent>
                {users?.map((user) => (
                  <SelectItem key={user._id} value={user._id}>
                    {user.nomeFantasia}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
    </div>
  );
};

export default CardTransferCard;
